import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X, Timer, ArrowRight } from "lucide-react";
import { REG_WINDOW_LABELS, currentRegWindow } from "@/data/site";

function daysLeft(iso) {
  const diff = new Date(iso).getTime() - Date.now();
  return Math.max(0, Math.ceil(diff / 86400000));
}

export default function AnnouncementBar() {
  const [open, setOpen] = useState(true);
  const [, setTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 3600000); // refresh hourly
    return () => clearInterval(id);
  }, []);

  if (!open) return null;

  const idx = currentRegWindow();
  const win = REG_WINDOW_LABELS[idx];
  const days = daysLeft(win.end);
  const isSpot = idx === 2;

  return (
    <div data-testid="announcement-bar" className="relative z-[60] bg-navy text-center text-xs sm:text-sm">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-2.5 px-10 py-2.5">
        <Timer className="hidden h-4 w-4 shrink-0 text-lime sm:block" />
        <p className="text-slate-300">
          {isSpot ? (
            <>
              <span className="font-semibold text-lime">Final-window pricing is live.</span>{" "}
              Seats for the inaugural edition are limited{" "}
            </>
          ) : (
            <>
              <span className="font-semibold text-lime">{win.label} pricing ends in {days} {days === 1 ? "day" : "days"}.</span>{" "}
              Lock the lowest rate before it rises{" "}
            </>
          )}
          <Link
            to="/register"
            data-testid="announcement-register"
            className="inline-flex items-center gap-1 font-semibold text-white underline-offset-4 hover:underline"
          >
            Book your pass <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        </p>
        <button
          data-testid="announcement-dismiss"
          onClick={() => setOpen(false)}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
